<template>
  <div>
    <div class="d-flex flex-wrap mb-3">
      <div class="mr-3 mb-2 mb-md-0" style="min-width: 100px">
        <label class="font-weight-bold">Filter by year</label>
        <div style="max-width: 120px">
          <f-search-select
            id="reports_year"
            :value="year"
            :options="years.map(y => ({ id: y, name: String(y) }))"
            :searchable="false"
            @input="$emit('year-change', Number($event))"
          />
        </div>
      </div>
      <div style="min-width: 200px">
        <f-search-select
          :id="draftSelectId"
          label="Drafts"
          :options="drafts"
          :value="draftId"
          :disabled="draftsLoading || drafts.length === 0"
          @input="$emit('draft-change', $event)"
        />
      </div>
    </div>

    <reports-toggle :active="active" class="mb-3" />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import FSearchSelect from '@/components/FormFields/FSearchSelect'
import ReportsToggle from '@/components/Reports/ReportsToggle'

export default defineComponent({
  name: 'ReportsFilterBar',
  components: { FSearchSelect, ReportsToggle },
  props: {
    years: { type: Array, required: true },
    year: { default: null },
    drafts: { type: Array, default: () => [] },
    draftId: { default: null },
    draftsLoading: { type: Boolean, default: false },
    active: { type: String, default: 'incoming' }
  },
  computed: {
    draftSelectId() {
      return `${this.active}Draft`
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Reports/ReportsFilterBar.vue